const cardElements = [
  {
    title: "Languages",
    value: "90%",
    content: (
      <>
        Skilled in python, C++, JavaScript,
        <br />
        <br />
        besides them, I use TypeScript, Rust, Java
        <br />
        <br />
      </>
    ),
  },

  {
    title: "Programming",
    value: "67%",
    content: (
      <>
        <ul className="list-disc ml-6">
          <li>Candidate Master @CodeForces, highest rating: 2029</li>
          <li>5&#9733; @CodeChef, highest rating: 2026</li>
        </ul>
        <br />
        <br />
      </>
    ),
  },

  {
    title: "Web Development",
    value: "75%",
    content: (
      <>
        <em>
          <u>Frontend:</u>
        </em>
        <br />
        React, TypeScript, TailwindCSS, GSAP, HTML, CSS, SCSS
        <br />
        <br />
        <em>
          <u>Backend:</u>
        </em>
        <br />
        Next.js, Flask, SQL, Express, MongoDB, Node, Dexie.js
        <br />
        <br />
        <em>
          <u>DevOps:</u>
        </em>
        <br />
        CI/CD Pipelines, AWS (EC2, S3, Lambda)
      </>
    ),
  },

  {
    title: "Machine Learning",
    value: "50%",
    content: (
      <>
        Studying, On it.
        <br />
        <br />
      </>
    ),
  },

  {
    title: "Core Subjects",
    value: "80%",
    content: (
      <>
        <ul className="list-disc ml-6">
          <li>Data Structures &amp; Algorithms</li>
          <li>Relational Database Management Systems</li>
          <li>Operating Systems</li>
          <li>Computer Networks</li>
          <li>Object Oriented System Design</li>
          <li>Automata Theory</li>
          <li>Digital Logic, Computer Organisation &amp; Architecture</li>
          <li>High Performance Computer Architecture</li>
        </ul>
        <br />
        <br />
      </>
    ),
  },
  {
    title: "Collaboration",
    value: "80%",
    content: (
      <>
        Can easily collaborate with team members using Git &amp; GitHub
        <br /> <br />
        <em>
          <u>Experience:</u>
        </em>
        <br />
        GDG CODEIIEST, Hactoberfest&apos;24
        <br />
        <br />
      </>
    ),
  },
];

export default cardElements;
